let language = {
    "CATALOG-SEARCH-CONTAINER-TITLE": "Search results for",
    "CATALOG-SEARCH-MENU-LIST-TITLE": "Sort by",
    "CATALOG-SEARCH-MENU-LIST-NEW": "New",
    "CATALOG-SEARCH-MENU-LIST-PRICE": "Price",
    "CATALOG-SEARCH-MENU-LIST-LOW-HIGH": "Low - High",
    "CATALOG-SEARCH-MENU-LIST-HIGH-LOW": "High - Low",
    "CATALOG-SEARCH-PLACE-HOLDER-SEARCH": "Search for",
    "CATALOG-SEARCH-EMPTY-TIPS": "Please enter keyword",
    "CATALOG-SEARCH--CATALOG-EMPTY-TIPS": "The catalog products is empty",
    "CATALOG-SEARCH--CATALOG-LIST-PRICE-TITLE": "as low as",
    "CATALOG-SEARCH--CATALOG-BUTTON-BACK": "Back",

};

export { language }